import { createAsyncThunk } from '@reduxjs/toolkit';
import { apiFetch } from '../../../utilities/appFetch';
import locationRoutes from '../../../components/location/locationRoutes';

const update = createAsyncThunk(
  'thunk/location/update',
  async (arg, thunkAPI) => {
    const response = await apiFetch(locationRoutes.api.generate.update(arg?.id), {
      body: arg?.data,
      method: 'POST',
    });
    if (!response?.success) {
      return thunkAPI.rejectWithValue(response);
    }
    return response.result;
  },
);

export default update;
